<eze-smart-form-container>
	<div header>
		<h1>{{ formName }} Registration</h1>
	</div>
	<div body>
		<h2 style="text-align: center; padding: 50px;">
			Sorry, registration has closed.
		</h2>
	</div>
	<div footer>
		<a href="/ez" class="btn btn-primary">
			Go Back Home
		</a>
		<a [href]="url" class="btn btn-warning" style="margin-right: 10px;">
			Go to Event Page <i class="fa fa-external-link"></i>
		</a>
	</div>
</eze-smart-form-container>
